import { useState, useCallback } from 'react';
import { ToastType } from '../components/common/Toast';

interface ToastState {
  show: boolean;
  message: string;
  description?: string;
  type: ToastType;
}

export const useToast = () => {
  const [toast, setToast] = useState<ToastState>({
    show: false,
    message: '',
    description: '',
    type: 'success'
  });

  const showToast = useCallback((
    message: string,
    options?: {
      description?: string;
      type?: ToastType;
    }
  ) => {
    setToast({
      show: true,
      message,
      description: options?.description,
      type: options?.type || 'success'
    });
  }, []);

  const hideToast = useCallback(() => {
    setToast(prev => ({ ...prev, show: false }));
  }, []);

  const success = useCallback((message: string, description?: string) => {
    showToast(message, { description, type: 'success' });
  }, [showToast]);

  const error = useCallback((message: string, description?: string) => {
    showToast(message, { description, type: 'error' });
  }, [showToast]);

  const warning = useCallback((message: string, description?: string) => {
    showToast(message, { description, type: 'warning' });
  }, [showToast]);

  const info = useCallback((message: string, description?: string) => {
    showToast(message, { description, type: 'info' });
  }, [showToast]);

  return {
    toast,
    showToast,
    hideToast,
    success,
    error,
    warning,
    info
  };
};
